import React from 'react';
import { Location } from 'history';
import { WithRouterProps } from 'react-router';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

type LanguageCode = string;

interface Language {
  code: LanguageCode;
  localisedText: string;
}

export interface OwnProps {
  className?: string;
  kind?: 'compact' | 'full';
}

interface Props {
  selected: LanguageCode;
  languages: Language[];
  onChangeLanguage: (language: string, location: Location) => void;
}

export class LanguageSwitcher extends React.PureComponent<
  Props & OwnProps & WithRouterProps
> {
  handleChange: React.ChangeEventHandler<HTMLSelectElement> = e => {
    const { onChangeLanguage, location } = this.props;

    onChangeLanguage(e.target.value, location);
  };

  renderValue = (code: string) => {
    const { languages, kind = 'compact' } = this.props;

    if (kind === 'compact') {
      return code.toUpperCase();
    }

    return (
      languages.find(lang => lang.code === code)?.localisedText ||
      code.toUpperCase()
    );
  };

  render() {
    const { selected, languages, className } = this.props;

    return (
      <div data-test-locator="Language switcher">
        {/* TODO: Define all needed variants either in LanguageSwitcher or select
          instead of passing down className */}
        <Select
          className={className}
          value={selected}
          onChange={this.handleChange}
          renderValue={this.renderValue}
          id="Language switcher"
        >
          {languages.map(({ code, localisedText }) => (
            <MenuItem
              key={code}
              value={code}
              data-test-locator={`Option ${code}`}
            >
              {localisedText}
            </MenuItem>
          ))}
        </Select>
      </div>
    );
  }
}

export default LanguageSwitcher;
